import React from 'react'
import i18n from 'i18next'

const ListStatusLabel = ({ status }) => {
    switch (status) {
        case 'complete':
            return (
                <div className="email-builder-status-label success">
                    <p>{i18n.t('sch_email_list_columns_passed')}</p>

                    <i className="far fa-circle-check" />
                </div>
            )
        case 'processing':
            return (
                <div className="email-builder-status-label warning">
                    <p>{i18n.t('sch_email_list_columns_processing')}</p>

                    <i className="far fa-arrows-rotate" />
                </div>
            )
        case 'failed':
        case 'empty':
        case 'notFound':
            return (
                <div className="email-builder-status-label error">
                    <p>{i18n.t('sch_email_list_columns_failed')}</p>

                    <i className="far fa-rotate-exclamation" />
                </div>
            )
        case 'sent':
            return (
                <div className="email-builder-status-label success">
                    <p>{i18n.t('sch_email_list_columns_sent')}</p>

                    <i className="far fa-envelope-circle-check" />
                </div>
            )
        case 'unsent':
            return (
                <div className="email-builder-status-label grey">
                    <p>{i18n.t('sch_email_list_columns_unsent')}</p>

                    <i className="far fa-envelope-open-text" />
                </div>
            )
        default:
            return (
                <div className="email-builder-status-label grey">
                    <p>{i18n.t('sch_email_list_columns_not_sent')}</p>
                </div>
            )
    }
}

export default ListStatusLabel
